/* OCC wishlist: explicit variants, live product detail, browser-only organisation.
   No cart writes, tracking, customer accounts or background sharing. */
(function () {
  'use strict';
  if (window.OCCWishlistUI || !window.OCCWishlistAdapter) return;
  window.OCCWishlistUI = true;
  let storage;
  try { storage = window.localStorage; }
  catch (_) { storage = {getItem(){throw new Error('Storage blocked');},setItem(){throw new Error('Storage blocked');}}; }
  const store = window.OCCWishlistAdapter.create(storage);
  window.OCCWishlistStore = store;
  let drawer, list, observer, lastFocused, previousOverflow='', generation=0;
  let products=new Map(), loading=false, removed=null, controllers=new Set(), actionNotice='';
  const key=window.OCCWishlistAdapter.key;
  const get=selector=>drawer?.querySelector(selector);
  const isOpen=()=>drawer?.classList.contains('is-open');
  const root=()=>window.Shopify?.routes?.root || drawer?.dataset.root || '/';
  function element(tag, className, text) {
    const node=document.createElement(tag);
    if(className)node.className=className;
    if(text!==undefined)node.textContent=text;
    return node;
  }
  function announce(text) { const node=get('[data-occ-wish-status]');if(node)node.textContent=text; }
  function storageWarning() {
    const node=get('[data-occ-wish-storage]');if(!node)return;
    node.textContent=store.warning()||actionNotice;node.hidden=!node.textContent;
  }
  function productURL(entry) {
    const url=new URL(root()+'products/'+encodeURIComponent(entry.handle),location.origin);
    if(entry.variantId)url.searchParams.set('variant',entry.variantId);
    return url;
  }
  function money(value) {
    if(typeof value!=='number'||!Number.isFinite(value))return 'Price unavailable';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-ZA',{style:'currency',currency:window.Shopify?.currency?.active||drawer?.dataset.currency||'ZAR'}).format(value/100);}
    catch(_){return 'Price unavailable';}
  }
  function view(entry) {
    const result=products.get(entry.handle), product=result?.product;
    const variant=entry.variantId?product?.variants?.find(v=>String(v.id)===entry.variantId):null;
    const known=!!product && (!entry.variantId||!!variant);
    return {entry,product,variant,error:result?.error,
      title:product?.title||entry.handle.replace(/-/g,' '),
      price:known?(variant?variant.price:product.price):null,
      available:known && (variant?variant.available:product.available)===true,
      known};
  }
  function visibleEntries() {
    return store.entries().map(view).sort((a,b)=>b.entry.savedAt-a.entry.savedAt);
  }
  function sync() {
    observer?.disconnect();
    const entries=store.entries();
    document.querySelectorAll('[data-occ-wishlist-count]').forEach(node=>{
      const text=String(entries.length);if(node.textContent!==text)node.textContent=text;
      node.hidden=!entries.length;
    });
    document.querySelectorAll('[data-occ-wishlist-open]').forEach(node=>node.setAttribute('aria-label','Wishlist, '+entries.length+(entries.length===1?' item':' items')));
    document.querySelectorAll('[data-occ-wish]').forEach(button=>{
      const handle=button.dataset.occWish, matches=entries.filter(entry=>entry.handle===handle);
      const generic=matches.some(entry=>!entry.variantId);
      const label=matches.length?(generic?'Remove saved product':'View saved options'):'Save to wishlist';
      button.classList.toggle('is-saved',!!matches.length);
      button.setAttribute('aria-pressed',String(!!matches.length));
      const text=button.querySelector('.occ-wish__sr');
      if(text&&text.textContent!==label)text.textContent=label;
    });
    storageWarning();
    if(observer)observer.observe(document.body,{childList:true,subtree:true});
  }
  function finishMutation(result,message) {
    actionNotice=result.ok?'':result.warning;
    sync();
    announce(result.ok?message:result.warning);
    if(result.warning&&!isOpen())openDrawer();
    return result.ok;
  }
  function safeImage(value) {
    if(!value)return null;
    try{const url=new URL(value,location.origin);if(!['http:','https:'].includes(url.protocol))return null;url.searchParams.set('width','200');return url.href;}
    catch(_){return null;}
  }
  function render(focusKey) {
    if(!list)return;
    const records=visibleEntries(), entries=store.entries();
    list.replaceChildren();list.setAttribute('aria-busy',String(loading));
    const share=get('[data-occ-wish-share]');if(share)share.disabled=loading||!entries.length;
    if(!entries.length)list.append(element('li','occ-wish-drawer__empty','Nothing saved yet. Tap a product heart to start your list.'));
    else if(loading)list.append(element('li','occ-wish-drawer__empty','Refreshing saved product details…'));
    else records.forEach(record=>{
      const {entry,product,variant}=record, entryKey=key(entry);
      const item=element('li','occ-wish-item');item.dataset.entryKey=entryKey;
      const media=element('a','occ-wish-item__media');media.href=productURL(entry).href;media.tabIndex=-1;media.setAttribute('aria-hidden','true');
      const src=safeImage(variant?.featured_image?.src||product?.featured_image||product?.images?.[0]);
      if(src){const image=element('img');image.src=src;image.alt='';image.width=80;image.height=80;image.loading='lazy';media.append(image);}
      else media.append(element('span','occ-wish-placeholder','OCC'));
      const info=element('div','occ-wish-item__info');
      const title=element('a','occ-wish-item__title',record.title);title.href=productURL(entry).href;info.append(title);
      if(product){
        if(record.known)info.append(element('span','occ-wish-item__price',(!entry.variantId&&product.price_varies?'From ':'')+money(record.price)));
        const availability=!record.known?'Saved option cannot currently be verified. Check the product page.':record.available?'Available now':'Currently unavailable';
        info.append(element('p','occ-wish-availability',availability));
        if(entry.variantId)info.append(element('p','occ-wish-option',variant?.title||'Saved option: '+entry.variantId));
        const options=element('div','occ-wish-options');
        const id='occ-wish-option-'+entryKey.replace(/[^a-z0-9-]/gi,'-');
        const label=element('label',null,'Saved size / colour');label.htmlFor=id;
        const select=element('select');select.id=id;select.dataset.occWishOption=entryKey;
        select.setAttribute('aria-label','Saved size / colour for '+record.title);
        select.append(new Option('No specific option saved',''));
        for(const option of product.variants){
          if(!/^[1-9]\d*$/.test(String(option.id)))continue;
          select.append(new Option(option.title+(option.available?'':' — unavailable'),String(option.id)));
        }
        if(entry.variantId&&!variant)select.append(new Option('Previously saved option (unverified)',entry.variantId));
        select.value=entry.variantId||'';
        const save=element('button',null,'Save option');save.type='button';save.dataset.occWishSaveOption=entryKey;
        save.setAttribute('aria-label','Save option for '+record.title);
        options.append(label,select,save);info.append(options);
        if(entry.variantId){
          const another=element('button','occ-wish-another','Save another size / colour');another.type='button';another.dataset.occWishAnother=entry.handle;info.append(another);
        }
        if(product.variants.length>=250)info.append(element('p','occ-wish-note','More options may be available on the product page.'));
      } else {
        info.append(element('p','occ-wish-availability',record.error==='not-found'?'This product is not available here. It is still saved.':"Couldn't refresh this product. It is still saved."));
        const retry=element('button',null,'Retry');retry.type='button';retry.dataset.occWishRetry='';info.append(retry);
      }
      const remove=element('button','occ-wish-item__remove','×');remove.type='button';remove.dataset.occWishRemove=entryKey;
      remove.setAttribute('aria-label','Remove '+record.title+(variant?' — '+variant.title:'')+' from wishlist');
      item.append(media,info,remove);list.append(item);
    });
    if(focusKey){
      const target=[...list.querySelectorAll('[data-entry-key]')].find(node=>node.dataset.entryKey===focusKey);
      (target?.querySelector('select,button,a:not([tabindex="-1"])')||get('[data-occ-wishlist-close]'))?.focus({preventScroll:true});
    }
    sync();
  }
  async function fetchProduct(handle, requestGeneration) {
    const controller=new AbortController();controllers.add(controller);
    const timeout=setTimeout(()=>controller.abort(),8000);
    try{
      const response=await fetch(root()+'products/'+encodeURIComponent(handle)+'.js',{signal:controller.signal,headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error(response.status===404?'not-found':'network');
      const product=await response.json();
      if(typeof product.title!=='string'||!Array.isArray(product.variants))throw new Error('invalid');
      if(requestGeneration===generation)products.set(handle,{product});
    }catch(error){if(requestGeneration===generation)products.set(handle,{error:error.message});}
    finally{clearTimeout(timeout);controllers.delete(controller);}
  }
  async function refresh() {
    if(!isOpen())return;
    controllers.forEach(controller=>controller.abort());controllers.clear();
    const current=++generation;products=new Map();loading=true;render();
    const handles=store.list(),deadline=Date.now()+12000;let index=0;
    // Bound a whole refresh as well as individual requests. A long list on a
    // weak connection must return usable recovery controls, not queue for minutes.
    const worker=async()=>{while(index<handles.length && current===generation && Date.now()<deadline){const handle=handles[index++];await fetchProduct(handle,current);}};
    await Promise.all(Array.from({length:Math.min(4,handles.length)},worker));
    if(current!==generation||!isOpen())return;
    loading=false;render();
    announce(store.entries().length+' saved '+(store.entries().length===1?'item':'items')+'. Details refreshed where available.');
  }
  function openDrawer() {
    if(!drawer||!list)return;
    if(!isOpen()){
      lastFocused=document.activeElement;previousOverflow=document.body.style.overflow;
      drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');drawer.removeAttribute('inert');
      document.body.style.overflow='hidden';get('[data-occ-wishlist-close]')?.focus();
    }
    if(get('[data-occ-wish-copy-fallback]'))get('[data-occ-wish-copy-fallback]').hidden=true;
    refresh();
  }
  function closeDrawer() {
    if(!isOpen())return;
    ++generation;controllers.forEach(controller=>controller.abort());controllers.clear();loading=false;
    drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');drawer.setAttribute('inert','');
    document.body.style.overflow=previousOverflow;
    if(lastFocused?.isConnected)lastFocused.focus();
    lastFocused=null;
  }
  async function share() {
    if(drawer?.dataset.sharingApproved!=='true'){announce('Product-link sharing is not enabled.');return;}
    const text=store.entries().map(entry=>{
      const record=view(entry),name=(record.title+(record.variant?' — '+record.variant.title:'')).replace(/[\r\n]+/g,' ');
      return name+'\n'+productURL(entry).href;
    }).join('\n\n');
    if(!text){announce('There are no saved product links to copy.');return;}
    try{
      if(!navigator.clipboard?.writeText)throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(text);announce('Product links copied. No account or order information was included.');
    }catch(_){
      const fallback=get('[data-occ-wish-copy-fallback]');fallback.hidden=false;
      const field=fallback.querySelector('textarea');field.value=text;field.focus();field.select();
      announce('Automatic copying is unavailable. Copy the selected product links below.');
    }
  }
  function init() {
    drawer=document.querySelector('[data-occ-wishlist-drawer]');list=get('[data-occ-wishlist-list]');
    sync();
    document.addEventListener('click',event=>{
      const target=event.target instanceof Element?event.target:null;if(!target)return;
      const wish=target.closest('[data-occ-wish]');
      if(wish){
        event.preventDefault();event.stopPropagation();
        const handle=wish.dataset.occWish;if(!window.OCCWishlistAdapter.validHandle(handle))return;
        const entries=store.entries().filter(entry=>entry.handle===handle);
        if(wish.hasAttribute('data-occ-wish-choose-options')){
          const purchase=document.querySelector('occ-purchase');
          const selected=purchase?.selected;
          const matching=selected && purchase.dataset.handle===handle && purchase.variants.some(v=>String(v.id)===String(selected.id));
          if(matching)finishMutation(store.add(handle,String(selected.id)),'Selected size and colour saved.');
          else if(!entries.length)finishMutation(store.add(handle),'Product saved. Choose an option in the wishlist.');
          openDrawer();
        }else if(entries.some(entry=>!entry.variantId)){
          finishMutation(store.removeEntry(handle+':product'),'Product removed from wishlist.');
        }else if(entries.length){openDrawer();}
        else{finishMutation(store.add(handle),'Product saved to wishlist.');}
        return;
      }
      if(target.closest('[data-occ-wishlist-open]')){event.preventDefault();openDrawer();return;}
      if(target.closest('[data-occ-wishlist-close]')||target.hasAttribute('data-occ-wishlist-overlay')){closeDrawer();return;}
      if(!drawer?.contains(target))return;
      const another=target.closest('[data-occ-wish-another]');
      if(another){const handle=another.dataset.occWishAnother;if(finishMutation(store.add(handle),'Choose the additional size / colour, then save the option.'))render(handle+':product');return;}
      const remove=target.closest('[data-occ-wish-remove]');
      if(remove){
        const entryKey=remove.dataset.occWishRemove,entry=store.entries().find(entry=>key(entry)===entryKey);
        if(entry){removed=entry;finishMutation(store.removeEntry(entryKey),'Item removed. You can undo this removal.');get('[data-occ-wish-undo]').hidden=false;render();get('[data-occ-wish-undo]').focus();}
        return;
      }
      if(target.closest('[data-occ-wish-undo]')){
        if(removed){finishMutation(store.restore(removed),'Saved item restored.');const restored=key(removed);removed=null;get('[data-occ-wish-undo]').hidden=true;render(restored);}
        return;
      }
      const save=target.closest('[data-occ-wish-save-option]');
      if(save){
        const entryKey=save.dataset.occWishSaveOption,select=save.closest('.occ-wish-options').querySelector('select');
        const entry=store.entries().find(entry=>key(entry)===entryKey),product=entry&&products.get(entry.handle)?.product;
        if(!entry||!product){announce('Refresh this product before saving an option.');return;}
        const id=select.value||null;
        if(id&&!product.variants.some(variant=>String(variant.id)===id)){announce('This option cannot currently be verified. Your previous choice is still saved.');return;}
        if(finishMutation(store.replace(entryKey,id),id?'Specific option saved.':'Product saved without a specific option.'))render(key({...entry,variantId:id}));
        return;
      }
      if(target.closest('[data-occ-wish-refresh],[data-occ-wish-retry]'))refresh();
      if(target.closest('[data-occ-wish-share]'))share();
    });
    document.addEventListener('keydown',event=>{
      if(!isOpen())return;
      if(event.key==='Escape'){event.preventDefault();closeDrawer();}
      if(event.key==='Tab'){
        const nodes=[...drawer.querySelectorAll('a[href]:not([tabindex="-1"]),button:not([disabled]),select:not([disabled]),textarea,summary,[tabindex="0"]')].filter(node=>node.checkVisibility()&&!node.closest('[hidden]'));
        const first=nodes[0],last=nodes[nodes.length-1];if(!first)return;
        if(event.shiftKey&&(document.activeElement===first||!drawer.contains(document.activeElement))){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&(document.activeElement===last||!drawer.contains(document.activeElement))){event.preventDefault();first.focus();}
      }
    });
    window.addEventListener('storage',event=>{
      if(event.key!==null&&!store.keys.includes(event.key))return;
      store.refresh();sync();if(isOpen())refresh();
    });
    document.addEventListener('shopify:section:load',()=>{drawer=document.querySelector('[data-occ-wishlist-drawer]');list=get('[data-occ-wishlist-list]');sync();});
    if('MutationObserver' in window){
      let queued=false;
      observer=new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});});
      observer.observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
